//------------------------------------------------------------------------------
// Execution conditions: on document ready
//------------------------------------------------------------------------------
document.addEventListener('DOMContentLoaded', function() {

  /**
   * Shared elements
   */
  const subNav = document.querySelector('nav#sub-nav');
  if( !subNav ) { // Stop here if there's no sub nav
    return;
  }
  const subNavOffsetTop = subNav.offsetTop; // Fetch base sub nav top position at document ready

  const header = document.querySelector('header');
  const sections = document.querySelectorAll('main section');
  const links = document.querySelectorAll('nav#sub-nav a');

  /**
   * Sticky sub-nav: general behaviour
   *
  */
  (function(){

    //
    // Function to be bound to scroll to toggle the sticky class
    //
    const setSubNavPosition = function() {

      // Define the point at which the sub nav should become sticky
      const scrollTrigger = subNavOffsetTop - header.offsetHeight - 50; // Account for the header height, as the sub-nav will stick to it.

      // Sticky if we are past the subnav
      if( window.scrollY >= scrollTrigger ) {
        subNav.classList.add('sticky');
        subNav.style.top = header.offsetHeight - 1 + 'px';
      }
      // Not sticky before the trigger
      else {
        subNav.classList.remove('sticky');
        subNav.style.top = '0px';
      }

    }

    //
    // Binding
    //
    setTimeout(setSubNavPosition, 50); // First time at document ready with a slight delay

    let shouldResize = false; // Queuing resize events
    window.addEventListener('scroll', function() { // On Scroll
      shouldResize = true;
    });

    window.addEventListener('resize', function() { // On resize
      shouldResize = true;
    });

    setInterval( function() {
      if( shouldResize ) {
        setSubNavPosition();
        shouldResize = false;
      }
    }, 15);

  })();

  /**
   * Sticky sub-nav: set respective element "active" when scrolling past it
   */
  (function() {

    //
    // Function
    //
    function setSubNavActiveLink() {

      // For each section
      let found = false;
      for( let i = 0; i < sections.length; i++ ) {

        // If the link to activate has already be found,
        // stop here, but don't break the loop to keep its closure alive
        if( found ) {
          return;
        }

        // For the current section in the loop
        const section = sections[i];

        // If the current scroll is before the next section (+ account for the element's own height + the header and subnav height)
        if( window.scrollY <= section.offsetTop + (section.offsetHeight - header.offsetHeight - subNav.offsetHeight) ) {
          // And that section has a link in the subnav
          const navLinkToActivate = document.querySelector(`nav#sub-nav a[href="#${section.id}"]`);
          if( navLinkToActivate ) {
            // Mark the link to activate as found
            found = true;

            // Deactivate the others
            activeLink = document.querySelector(`nav#sub-nav a.active`);
            if( activeLink ) {
              activeLink.classList.remove('active');
            }

            // Activate it
            navLinkToActivate.classList.add('active');
          }

        }

      }

    }

    //
    // Binding
    //
    setTimeout(setSubNavActiveLink, 50); // First time at document ready with a slight delay

    let shouldActivate = false; // Queuing resize events
    window.addEventListener('scroll', function() { // On Scroll
      shouldActivate = true;
    });

    window.addEventListener('resize', function() {     // On resize
      shouldActivate = true;
    });

    setInterval( function() {
      if( shouldActivate ) {
        setSubNavActiveLink();
        shouldActivate = false;
      }
    }, 15);


  })();


  /**
   * Sticky Sub-nav smooth scroll
   */
  (function() {

    // Apply to each link
    for( let i = 0; i < links.length; i++ ) {
      links[i].addEventListener('click', function(e) {
        e.preventDefault();

        // Get the element the link is refering to
        const target = document.querySelector(this.hash);
        if( !target ) {
          return;
        }

        // Smooth scroll to that element
        window.scroll({
          top: (target.offsetTop - header.offsetHeight - subNav.offsetHeight) + 15,
          left: 0,
          behavior: 'smooth'
        });
      });
    }

  })();

});
